module.exports = __webpack_public_path__ + "img/works_kuraray_miniapp_3@3x.ceeb4b18.png";